export default {
    createJob: 'Create Job',
    updateJob: 'Edit Job',
    jobName: 'Branch Name',
    save: 'Save',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error message',
    jobIsCreated: 'Job is created',
    jobIsUpdated: 'Job is updated'
}
